import {request} from "../request/request";

const verifyEmail = {
  getVerifyEmail: (token) => request.read(`/verify-email/${token}`),
};

export {verifyEmail};